// Bagian murni dari path-slug — dipisah tanpa "use client"/next agar bisa
// diuji offline via tsx (lihat src/lib/routes.test.mjs).
//
// Static export + fallback HTML ("/webinar/_/index.html") membuat useParams()
// selalu mengembalikan "_" di production — slug dinamis WAJIB dibaca dari URL
// browser (lihat apps/web/CLAUDE.md). Semua parsing segmen lewat util ini agar
// polanya tidak diketik ulang manual di tiap halaman.
export function pathSegments(pathname: string): string[] {
  return pathname.split("/").filter(Boolean);
}
